import { ModuleWithProviders, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { ENVIRONMENT } from './constants';
import { AtxHttpClientInterceptorResponse, AtxHttpClientInterceptorRequest} from './interceptors';

@NgModule({
    imports: [
        HttpClientModule,
    ],
    providers: [
        HttpClient,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AtxHttpClientInterceptorRequest,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AtxHttpClientInterceptorResponse,
            multi: true,
        },
    ],
})

export class AtxHttpClientInterceptorModule {
    static forRoot(environment): ModuleWithProviders {
        return {
            ngModule: AtxHttpClientInterceptorModule,
            providers: [
                {
                    multi: true,
                    provide: ENVIRONMENT,
                    useValue: environment,
                },
            ],
        };
    }}
